import * as tableauDeBord from './tableauDeBord/tableauDeBord';
import * as connexion from './connexion/connexion';
import * as header from './header/header';
import * as recommandation from './recommandation/recommandation';
import * as general from './general/general';
import * as parametre from './general/parametre';
import * as panier from './panier/panier';
import * as recapRecom from './recapRecom/recapRecom';
import * as menu from './menu/menu';
import * as client from './client/client';
import * as detailClient from './detailClient/detailClient';
import * as applicationTVAType from './applicationTVAType/applicationTVAType';
import * as devisAchat from './devisAchat/devisAchat';
import * as validation from './general/validation';
import errors from './general/errors';

export const PAGES = {
  general: general.GENERAL,
  tableauDeBord: tableauDeBord.TABLEAU_DE_BORD,
  connexion: connexion.CONNEXION,
  header: header.HEADER,
  pointDeVente: recommandation.POINT_DE_VENTE,
  creerPointDeVente: recommandation.CREER_POINT_DE_VENTE,
  creerPanneau: recommandation.CREER_PANNEAU,
  headerPanier: panier.HEADER_PANIER,
  produitsPanier: panier.PRODUITS_PANIER,
  listePanneau: recommandation.LISTE_PANNEAU,
  recapEnseigne: recapRecom.RECAP_ENSEIGNE,
  recapRecom: recapRecom.RECAP_RECOM,
  recapBudgetaire: recapRecom.RECAP_BUDGETAIRE,
  envoiMail: recapRecom.ENVOI_MAIL,
  modifierPointDeVente: recommandation.MODIFIER_POINT_DE_VENTE,
  modifierPanneau: recommandation.MODIFIER_PANNEAU,
  menu: menu.MENU,
  listeClient: client.LISTE_CLIENT,
  creerClient: client.CREER_CLIENT,
  modifierClient: client.MODIFIER_CLIENT,
  infoClient: detailClient.INFO_CLIENT,
  detailClient: detailClient.DETAIL_CLIENT,
  listeRecomClient: detailClient.LISTE_RECOM_CLIENT,
  ajoutContact: client.AJOUT_CONTACT,
  recapPageDeGarde: recapRecom.RECAP_PAGE_DE_GARDE,
  concurrent: recommandation.CONCURRENT,
  applicationTVAType: applicationTVAType.APPLICATION_TVA_TYPE,
  parametre: parametre.PARAMETRES,
  devis: recommandation.DEVIS,
  listeDevisAchat: devisAchat.DEVIS_ACHAT,
  errors: errors,
  ajoutProduitExistant: recommandation.AJOUT_PRODUIT_EXISTANT,
  validation: validation.VALIDATION,
};
